import { Injectable } from "@angular/core";

@Injectable()
export class TabContext {
    nextTabId = 1000;
}